module.exports = __webpack_public_path__ + "static/media/eye-outline.cf8453ed.svg";